export default __webpack_public_path__ + "app/audio/jump.mp3";